import {
    Box,
    Stack,
    Typography,
    useTheme
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import './banner.css';

const BannerView = () => {
    const theme = useTheme();

    return (
        <>
            <Stack
                direction='column'
                position='relative'
                width='100%'
                justifyContent='center'
                alignItems='center'
                overflow="hidden"
                py={{xs: 10, md: 30}}
                sx={{
                    backgroundColor: theme.palette.primary.main,
                }}
            >
                <Banner color='#ede7d2'/>

                <Banner color='#ff7143' behind/>
            </Stack>
        </>
    );
}

export default BannerView;

const Banner = ({color, behind=false}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Stack
                direction='row'
                justifyContent='start'
                alignItems='center'
                py={{xs: 1, md: 1.5}}
                sx={{
                    position: 'absolute',
                    backgroundColor: color,
                    width: behind ? '200%' : '150%',
                    zIndex: behind ? 1 : 2,
                    transform: behind ? 'rotate(-5deg)' : 'rotate(0deg)'
                }}
                spacing={{xs: 2, md: 5}}
            >
                {
                    [0,1,2,3].map((item) => {
                        return <Stack
                            key={item}
                            direction='row'
                            justifyContent='start'
                            alignItems='center'
                            spacing={{xs: 2, md: 5}}
                            data-aos={behind ? "fade-right" : "fade-left"}
                            data-aos-duration="1000"
                        >
                            {/* Fish */}
                            <Box
                                sx={{
                                    width: {xs: 50, md: 100}
                                }}
                            >
                                <img 
                                    src={item %2 === 0 ? '/images/game/Fish-3.png' : '/images/game/Fish-5.png'}
                                    alt='fish' 
                                    width='100%'
                                    style={{
                                        animation: item %2 === 0 ? 'bannerFish1 2s infinite linear' : 'bannerFish2 2s infinite linear'
                                    }} 
                                />
                            </Box>

                            {/* Banner text */}
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: {xs: 16, md: 24, lg: 32},
                                    color: theme.palette.secondary.main,
                                    textTransform: 'uppercase'
                                }}
                                noWrap
                            >
                                {t('banner')}
                            </Typography>
                        </Stack>
                    })
                }
            </Stack>
        </>
    );
}